import { createContext, useContext, useState, type ReactNode } from 'react'

type AgentId = 'david' | 'hanna'

interface SelectedAgentContextValue {
  selectedAgentId: AgentId
  setSelectedAgentId: (id: AgentId) => void
}

const SelectedAgentContext = createContext<
  SelectedAgentContextValue | undefined
>(undefined)

export function SelectedAgentProvider({ children }: { children: ReactNode }) {
  const [selectedAgentId, setSelectedAgentId] = useState<AgentId>('david')

  return (
    <SelectedAgentContext.Provider
      value={{ selectedAgentId, setSelectedAgentId }}>
      {children}
    </SelectedAgentContext.Provider>
  )
}

export function useSelectedAgent(): SelectedAgentContextValue {
  const ctx = useContext(SelectedAgentContext)
  if (!ctx) {
    throw new Error(
      'useSelectedAgent must be used within SelectedAgentProvider'
    )
  }
  return ctx
}
